export default "__VITE_ASSET__JWSOd4p9__"